import { evalActionsSchema, EvalTestCaseTypeEnum } from "@repo/schema";
import { issueKey, tKey } from "@/core/i18n";
import { z } from "zod";

export const createTestCaseFormSchema = z.object({
  name: z.string().min(1, issueKey(tKey("evaluation:form.errors.nameRequired"))),
  type: z.enum(EvalTestCaseTypeEnum),
  actions: evalActionsSchema,
  enabled: z.boolean(),
});

export type CreateTestCaseFormSchema = z.infer<typeof createTestCaseFormSchema>;
